// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__19XKn","question":"Question_question__2PzlM","description":"Question_description__2qV4I"};